/*
TODO: move code from following files to one generic file and use that 
    src/components/modals/UserDetails/components/DetailsForm/index.tsx
    src/components/eventPage/components/RebookingForm/DetailsForm.tsx
    src/components/pay/DetailsForm/index.tsx
*/
import React from "react";
import {
    FORM_ENUM,
    FORM_FIELDS,
} from "@Modules/modals/components/UserDetails/FormData";
import { classNames } from "repoV2/utils/common/render/classNames";
import { DropdownSelector } from "@Modules/common/Form";
import { IDropdownSelector } from "@Modules/common/Form/FormInputs/DropdownSelector/IDropdownSelector";
import styles from "../../../../event.module.scss";
import { IDetailsForm } from "../../IRenewBookingForm";
import useDetailsForm from "./useDetailsForm";

export const DetailsForm = (props: IDetailsForm.IProps) => {
    const { isMobile, formDetails, formFields } = props;

    const { handleDropdownSelectChange, handleFieldBlur, handleFormChange } =
        useDetailsForm(props);

    return (
        <>
            {formFields.map(formField => {
                const formFieldDetails = formDetails[formField];
                const formFieldProps = FORM_ENUM[formField];
                if (
                    ["text", "email"].includes(formFieldProps?.inputType || "")
                ) {
                    return (
                        <div key={formField}>
                            <div
                                className={classNames(
                                    styles.textInputLabel,
                                    isMobile && styles.textInputLabelMobile
                                )}
                            >
                                {formField === FORM_FIELDS.email
                                    ? "Your Registered Email address"
                                    : formFieldProps?.label}
                            </div>
                            {formField === FORM_FIELDS.email ? (
                                <div
                                    className={classNames(
                                        styles.textInputDescription,
                                        isMobile &&
                                            styles.textInputDescriptionMobile
                                    )}
                                >
                                    Enter the email address used for your
                                    previous booking
                                </div>
                            ) : null}
                            <input
                                type={formFieldProps?.inputType}
                                name={formFieldProps?.id}
                                className={styles.textInput}
                                placeholder={`Enter ${formFieldProps?.label}`}
                                id={`rebookingInfo-${formFieldProps?.id}`}
                                onChange={handleFormChange}
                                onBlur={handleFieldBlur}
                                value={formFieldDetails?.value || ""}
                            />
                            <div
                                className={classNames(
                                    styles.textInputDescription,
                                    styles.textInputWarning
                                )}
                            >
                                {formFieldDetails?.showError &&
                                formFieldDetails?.error ? (
                                    formFieldDetails?.error
                                ) : (
                                    <>&nbsp;</>
                                )}
                            </div>
                        </div>
                    );
                }
                if (formFieldProps?.inputType === "select") {
                    const options = formFieldProps?.data.map(
                        (item: { label: string; value: string }) => ({
                            ...item,
                            name: formField,
                        })
                    );
                    const value = options.find(
                        (option: IDropdownSelector.Option) =>
                            option.value === formFieldDetails?.value
                    );
                    return (
                        <div key={formField}>
                            <div
                                className={classNames(
                                    styles.textInputLabel,
                                    isMobile && styles.textInputLabelMobile
                                )}
                            >
                                {formFieldProps?.label}
                            </div>
                            <DropdownSelector
                                onChange={handleDropdownSelectChange}
                                placeholder={`Enter ${formFieldProps?.label}`}
                                id={`rebookingInfo-${formFieldProps?.id}`}
                                value={value}
                                name={formField}
                                options={options}
                                className={styles.dropdownSelector}
                                autoSelect="FIOOO"
                            />
                            <div
                                className={classNames(
                                    styles.textInputDescription,
                                    styles.textInputWarning
                                )}
                            >
                                {formFieldDetails?.showError &&
                                formFieldDetails?.error ? (
                                    formFieldDetails?.error
                                ) : (
                                    <>&nbsp;</>
                                )}
                            </div>
                        </div>
                    );
                }
                return null;
            })}
        </>
    );
};
